export class ShareImageService {
    start() {
        void this.loadInitialImageAndPrefetchOthers();
    }
    dispose() {
        this.disposed = true;
        this.revokeAllImageUrls();
    }
    async getImageFile(index) {
        const imageItem = this.imageItems[index];
        if (imageItem == undefined) return undefined;
        if (imageItem.imageFileCache.status == 'resolved') return imageItem.imageFileCache.file;
        if (imageItem.imageFileCache.status == 'loading') return imageItem.imageFileCache.promise;
        const imageFilePromise = imageItem.image.getImageFile();
        imageItem.imageFileCache = {
            status: 'loading',
            promise: imageFilePromise
        };
        const imageFile = await imageFilePromise;
        imageItem.imageFileCache = {
            status: 'resolved',
            file: imageFile
        };
        return imageFile;
    }
    async loadInitialImageAndPrefetchOthers() {
        const firstImageIndex = 0;
        await this.loadImage(firstImageIndex);
        if (this.disposed) return;
        for(let index = firstImageIndex + 1; index < this.imageItems.length; index++){
            void this.loadImage(index);
        }
    }
    async loadImage(index) {
        const imageItem = this.imageItems[index];
        if (imageItem == undefined) return;
        if (imageItem.previewState.status != 'idle') return;
        this.setImage(index, {
            status: 'loading'
        });
        const imageFile = await this.getImageFile(index);
        if (this.disposed) return;
        const loadedImage = imageFile == undefined ? {
            status: 'error'
        } : {
            status: 'ready',
            imageUrl: URL.createObjectURL(imageFile)
        };
        this.setImage(index, loadedImage);
    }
    setImage(index, image) {
        const imageItem = this.imageItems[index];
        if (imageItem == undefined) return;
        imageItem.previewState = image;
        this.notifyChange();
    }
    revokeAllImageUrls() {
        for (const imageItem of this.imageItems){
            const previewState = imageItem.previewState;
            if (previewState.status == 'ready') URL.revokeObjectURL(previewState.imageUrl);
        }
    }
    notifyChange() {
        const imageStates = this.imageItems.map((imageItem, index)=>{
            const achievementEnum = imageItem.image.kind == 'playerTitle' ? imageItem.image.achievementEnum : undefined;
            return {
                title: imageItem.image.title,
                previewState: imageItem.previewState,
                achievementEnum: achievementEnum,
                getImageFile: ()=>this.getImageFile(index)
            };
        });
        this.onStateChange(imageStates);
    }
    constructor(onStateChange, images){
        this.disposed = false;
        this.onStateChange = onStateChange;
        this.imageItems = images.map((image)=>({
                image: image,
                previewState: {
                    status: 'idle'
                },
                imageFileCache: {
                    status: 'idle'
                }
            }));
    }
}
